import { makeApiRequest } from "./apiBody"
 

async function serviceExists(values) {
  try {
    const data = {
        "serviceProviderPrimaryEmail": values
    }
    
    const response = makeApiRequest({
      serviceName: 'serviceprovider',
      resourceName: 'profile',
      actionName: 'byEmail',
      data
    });
     console.log("searchres==", response)
    return response;
    
  } catch (err) {
    throw err; // Let the caller handle the error
  }
}

// if the do not exist navigate user to enter sp details  and use this api
 
async function registerServiceProvider(values) {
    console.log("VALUES===*&", values)
  try {
    const data = {
      "serviceProviderNames": values.name,
      "serviceProviderPrimaryEmail": values.email,
      "serviceProviderCategory": values.category,
      "contact":{
        "name": values.contactPerson.name,
        "email": values.contactPerson.email
      }
  }
    
    const response = makeApiRequest({
      serviceName: 'serviceprovider',
      resourceName: 'registration',
      actionName: 'entityRegistration',
      data
    });

    return response;
  } catch (err) {
    throw err; // Let the caller handle the error
  }
}


// if the do exists use the below to add to panel

async function addServiceToPanel(values) {
    console.log("adding to panel", values)
  try {
    const data = {
        "serviceProviderSystemRef": values
    }
    
    const response = makeApiRequest({
      serviceName: 'serviceprovider',
      resourceName: 'panel',
      actionName: 'addServiceProviderToPanel',
      data
    });

    return response;
  } catch (err) {
    throw err; // Let the caller handle the error
  }
}


//  ...Use this api to list all the service providers in the intermediary Panel
async function listServiceProviders(values) {
  try { 
    const response = makeApiRequest({
      serviceName: 'serviceprovider',
      resourceName: 'panel',
      actionName: 'list',
      data: {}
    });

    return response;
  } catch (err) {
    throw err; // Let the caller handle the error
  }
}



export {
    serviceExists,
    listServiceProviders,
    addServiceToPanel,
    registerServiceProvider,
}